import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import Recovery from "@/components/Recovery";
import Forgot from "@/components/Forgot";
import Wrapper from "@/components/Wrapper";
import NotFound from "@/components/NotFound";

import Dashboard from "@/components/Dashboard.vue";
import Donamakers from "@/components/Donamakers/Index";

import Clients from "@/components/Customers/Index";
import EditLegal from "@/components/Customers/Legals/Edit";
import EditPhysical from "@/components/Customers/Physicals/Edit";

import Professionals from "@/components/Professionals/Index.vue";
import ProfessionalsEdit from "@/components/Professionals/Edit/Index.vue";
import ProfessionalRegisterFlow from "@/components/ProfessionalRegisterFlow/Index";
import ProfessionalTrainingFlow from "@/components/ProfessionalTrainingFlow/Index";
import Cities from "@/components/Cities/Index.vue";

import Orders from "@/components/Orders/List.vue";
import ShowOrder from "@/components/Orders/ShowOrder/Index.vue";
import PurchaseFlow from "@/components/PurchaseFlow/Index.vue";
import Rebooking from "@/components/Orders/Rebooking/Index.vue";

import Subscription from "@/components/Subscription/Index.vue";
import NewSubscription from "@/components/Subscription/NewSubscription/Index.vue";

import WalletOfCompany from "@/components/WalletOfCompany/Index.vue";
import Transfers from "@/components/Transfers/Index.vue";

import Coupons from "@/components/Coupons/Index.vue";

import Notifications from "@/components/Notifications/Index.vue";

import store from "../store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      alias: "",
      component: Login
    },
    {
      path: "/esqueci-minha-senha",
      name: "recovery",
      component: Recovery
    },
    {
      path: "/redefina-sua-senha",
      name: "forgot",
      component: Forgot
    },
    {
      path: "/",
      name: "wrapper",
      component: Wrapper,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          name: "dashboard",
          path: "dashboard",
          component: Dashboard
        },
        {
          name: "donamakers",
          path: "donamakers",
          component: Donamakers
        },
        {
          name: "clients",
          path: "clientes",
          component: Clients
        },
        {
          name: "clients-b2b-edit",
          path: "clientes/b2b/:id",
          component: EditLegal
        },
        {
          name: "clients-b2c-edit",
          path: "clientes/b2c/:id",
          component: EditPhysical
        },
        {
          name: "professionals",
          path: "profissionais",
          component: Professionals
        },
        {
          name: "professionals-edit",
          path: "profissionais/:id",
          component: ProfessionalsEdit
        },
        {
          name: "cities",
          path: "cidades",
          component: Cities
        },
        {
          name: "orders",
          path: "pedidos",
          component: Orders
        },
        {
          name: "order",
          path: "pedido/:id",
          component: ShowOrder
        },
        {
          name: "new-order",
          path: "novo-pedido",
          component: PurchaseFlow
        },
        {
          name: "rebooking",
          path: "pedido/:id/reagendar",
          component: Rebooking
        },
        {
          name: "subscription",
          path: "assinaturas",
          component: Subscription
        },
        {
          name: "new-subscription",
          path: "nova-assinatura",
          component: NewSubscription
        },
        {
          name: "wallet-of-company",
          path: "carteira",
          component: WalletOfCompany
        },
        {
          name: "transfers",
          path: "transferencias",
          component: Transfers
        },
        {
          name: "coupons",
          path: "cupons",
          component: Coupons
        },
        {
          name: "notifications",
          path: "notificacoes",
          component: Notifications
        },
        {
          name: "professional-register-flow",
          path: "cadastro-profissionais",
          component: ProfessionalRegisterFlow
        },
        {
          name: "professional-training-flow",
          path: "treinamento-profissionais",
          component: ProfessionalTrainingFlow
        },
        {
          path: "*",
          name: "not-found",
          component: NotFound
        }
      ]
    },
    {
      path: "*",
      name: "not-found2",
      component: NotFound
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  try {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = await store.dispatch("user/isAuthenticated");

    if (requiresAuth && !isAuthenticated) return next("/login");
    if (!requiresAuth && isAuthenticated) return next("/dashboard");

    store.dispatch("sidebar/setRoute", to.name);

    return next();
  } catch (e) {
    return next("/login");
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js